module.exports = __webpack_public_path__ + "img/homepage_0.ed25d915.jpg";